import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../../libs/utils/Const";
import { development } from "../../../libs/utils/Const";
import config from "../../../config";

class DetailInvoiceR extends Component {
    render() {
        const { ReportResInvoiceModel, Printed } = this.props
        const printDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
        const currentUser = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        return (
            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginBottom: "100px" }}>
                <div className="row">
                    <div className="col-3">
                        <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong></strong></p>
                    </div>
                    <div className="col-9 text-center">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h5><strong>DETALLE DE FACTURAS DE RESERVA</strong></h5>
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-12 text-center">
                                <table>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th className="text-center" colSpan={2}>Sucursal</th>
                                            <th className="text-center">Desde</th>
                                            <th className="text-center">Hasta</th>
                                            <th className="text-center">Fecha y hora</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-right">{ReportResInvoiceModel.BranchOffice ?? ''}</td>
                                            <td className="text-center">{ReportResInvoiceModel.BranchOfficeName ?? ''}</td>
                                            <td className="text-center">{ReportResInvoiceModel.InitialDate ?? ''}</td>
                                            <td className="text-center">{ReportResInvoiceModel.FinalDate ?? ''}</td>
                                            <td className="text-center">{printDate ?? ''}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-12'>
                        <table>
                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                <tr>
                                    <th className="text-center">FACTURAS DE RESERVA</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col-12'>
                        <table>
                            <thead>
                                <tr style={{ borderBottom: 'solid black 1px', marginBottom: '5px' }}>
                                    <th className="text-left">Folio</th>
                                    <th className="text-left">Cliente</th>
                                    <th className="text-left">Nombre</th>
                                    <th className="text-right">Fecha</th>
                                    <th className="text-center">Estatus</th>
                                    <th className="text-right">Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ReportResInvoiceModel && ReportResInvoiceModel.ReserveInvoices &&
                                    ReportResInvoiceModel.ReserveInvoices.map((invoice, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-left" style={{ width: "10vw" }}>{invoice.NumAtCard ?? ''}</td>
                                                <td className="text-left">{invoice.CardCode ?? ''}</td>
                                                <td className="text-left">{invoice.CardName ?? ''}</td>
                                                <td className="text-right">{moment(invoice.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                                <td className="text-center">{invoice.InvntSttus === 'C' ? 'Entregado' : 'Pendiente'}</td>
                                                <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(invoice.DocTotal ?? 0.00)}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-7'></div>
                    <div className='col-5'>

                        <table>
                            <tbody style={{ borderTop: "solid 1px" }}>
                                <tr>
                                    <td className='text-right p-2' style={{ background: "#ddd" }}><strong>GRAN TOTAL: </strong></td>
                                    <td className='text-right p-2 mr-2' style={{ background: "#ddd" }}><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(ReportResInvoiceModel.Total ?? 0)}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col-12'>
                        <table>
                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                <tr>
                                    <th className="text-center" colSpan="2">ENTREGAS</th>
                                </tr>
                            </thead>

                        </table>
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col-12'>
                        <table className='mt-2'>
                            <thead >
                                <tr>
                                    <th className="text-left">Factura de reserva</th>
                                    <th className="text-left">Folio de entrega</th>
                                    <th className="text-left">Cliente</th>
                                    <th className="text-left">Nombre</th>
                                    <th className="text-right">Fecha</th>
                                    <th className="text-right">Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ReportResInvoiceModel && ReportResInvoiceModel.ReserveInvoices &&
                                    ReportResInvoiceModel.ReserveInvoices.map((invoice, index) => {
                                        if (invoice.Deliveries.length === 0) { return (<></>); }

                                        return (
                                            <>
                                                <tr key={index} style={{ borderTop: 'solid black 1px', marginTop: '5px' }}>
                                                    <td className="text-left" rowSpan={invoice.Deliveries.length} style={{ width: "10vw", verticalAlign: "top" }}>{invoice.NumAtCard ?? ''}</td>
                                                    <td className="text-left" style={{ width: "10vw" }}>{invoice.Deliveries[0].NumAtCard ?? ''}</td>
                                                    <td className="text-left">{invoice.Deliveries[0].CardCode ?? ''}</td>
                                                    <td className="text-left">{invoice.Deliveries[0].CardName ?? ''}</td>
                                                    <td className="text-right">{moment(invoice.Deliveries[0].DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                                    <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(invoice.Deliveries[0].DocTotal ?? 0.00)}</td>
                                                </tr>
                                                {invoice.Deliveries.map((delivery, index) => {
                                                    if (index === 0) { return (<></>); }

                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-left" style={{ width: "10vw" }}>{delivery.NumAtCard ?? ''}</td>
                                                            <td className="text-left">{delivery.CardCode ?? ''}</td>
                                                            <td className="text-left">{delivery.CardName ?? ''}</td>
                                                            <td className="text-right">{moment(delivery.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                                            <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(delivery.DocTotal ?? 0.00)}</td>
                                                        </tr>
                                                    );
                                                })}
                                                <br />
                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div >

                {Printed &&
                    <div className='row mt-4'>
                        <div className='col-12'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Impreso por: {currentUser.USER_CODE ?? ''}</th>
                                    </tr>
                                </thead>

                            </table>
                        </div>
                    </div>
                }
            </div >
        )
    }
}

export default DetailInvoiceR